import * as angular from 'angular';

import { ContextualField, ComponentDefinition, AggregationMode, PropertyType } from '../../models';
import * as Fields from '../../common/helpers/contextual';
import { ColoringMode } from '../../models/widgets/ColoringMode';
import { ChartIdentifierWidgetConfiguration } from '../../widgets';

class GaugeChartContextualController implements angular.IComponentController, angular.IOnInit {

    configuration: ChartIdentifierWidgetConfiguration;
    properties: ContextualField[];
    save: () => void;
    cancel: () => void;

    private _originalConfiguration: ChartIdentifierWidgetConfiguration;

    static $inject = ['$q'];

    constructor(private _$q: angular.IQService) {
    }

    $onInit() {
        const aggregationMode = angular.copy(Fields.AggregationMode);
        aggregationMode.isValid = (value: AggregationMode) => { return { 'value': value !== AggregationMode.None && value !== AggregationMode.Delta && value !== AggregationMode.Integration }; };
        aggregationMode.messages = [{ key: 'value', value: 'A valid aggregation mode must be selected.' }];

        const colorField: ContextualField = angular.copy(Fields.Color);
        colorField.disabled = this.configuration.options.coloringMode === ColoringMode.BySerie;

        const coloringModeField: ContextualField = angular.copy(Fields.ColoringMode);
        coloringModeField.onChange = (viewValue: number) => {
            colorField.disabled = viewValue === ColoringMode.BySerie;
        };

        const fieldMin = angular.copy(Fields.Min);
        fieldMin.extraData = { subProperty: 'options' };
        const fieldMax = angular.copy(Fields.Max);
        fieldMax.extraData = { subProperty: 'options' };

        const fieldSeverities: ContextualField = {
            modelName: 'severities',
            propertyType: PropertyType.Severities,
            label: 'Severities',
            propertyName: 'severitiesProperty',
            required: false,
            icon: 'fa-bell',
            disabled: !this.configuration.options.showAlarms,
            extraData: { subProperty: 'options' }
        };
        const showAlarms = angular.copy(Fields.ShowAlarms);
        showAlarms.onChange = (viewValue, extraArgs) => fieldSeverities.disabled = !viewValue;
        showAlarms.extraData = { subProperty: 'options' };

        this.properties = [
            angular.copy(Fields.Title),
            angular.copy(Fields.IsTitleVisible),
            angular.copy(Fields.IsLegendVisible),
            coloringModeField,
            colorField,
            angular.copy(Fields.Thickness),
            fieldMin,
            fieldMax,
            aggregationMode,
            angular.copy(Fields.MinPeriod),
            angular.copy(Fields.MaxPeriod),
            angular.copy(Fields.PeriodReference),
            angular.copy(Fields.ShowTarget),
            showAlarms,
            fieldSeverities,
            angular.copy(Fields.IsEndDateIncluded),
            angular.copy(Fields.NameConfiguration.HasGroupName),
            angular.copy(Fields.NameConfiguration.HasName),
            angular.copy(Fields.NameConfiguration.HasShortComment),
            angular.copy(Fields.NameConfiguration.HasUnit),
            angular.copy(Fields.NameConfiguration.HasValueType)
        ];
    }

    onSave(): angular.IPromise<void> {
        return this._$q.when(this.save());
    }

    onCancel() {
        this.configuration = angular.copy(this._originalConfiguration);
        this.cancel();
    }
}

export const wtGaugeChartContextual: ComponentDefinition = {
    componentId: 'wtGaugeChartContextual',
    controller: GaugeChartContextualController,
    controllerAs: 'vm',
    template: require('./gaugeChart.contextual.html'),
    bindings: {
        configuration: '<',
        formController: '=',
        isBindable: '<?',
        //dashboards: '<'
        save: '&?',
        cancel: '&?'
    }
};